<template>
    <v-card
        max-width="430"
        class="grey lighten-4 m-6"
    >
        <v-card-title>
            {{ title }}
        </v-card-title>

        <v-card-subtitle>
            {{ subtitle }}
        </v-card-subtitle>

        <v-card-text>
            {{ quote }}
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "QuoteCard",
    props: {
        /**
         * The main content of the card.
         */
        quote: {
            type: String,
            default: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque
             ut massa a mauris tempus fermentum. Praesent gravida pellentesque
             tempor. Pellentesque molestie risus neque, id euismod lacus rhoncus
             in. Quisque ut blandit lacus. In in erat tempor purus accumsan volutpat
             cursus vel neque. Nam fermentum faucibus vehicula. Etiam ac molestie
             velit. Cras tincidunt quam ipsum, posuere euismod ante mollis quis.
             Curabitur cursus,tellus eget gravida venenatis, nunc mi varius lorem, at 
             scelerisque urna odio vel dui.`
        },
        /**
         * The card title.
         */
        title: {
            type: String,
            default: "Keep Moving Forward."
        },
        /**
         * The subtitle of the card.
         */
        subtitle: {
            type: String,
            default: "John Li"
        }
    }
}
</script>
